import React, { FC } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Button } from "@mui/material";
import { CustomCellRendererProps } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import { EMPLOYEE_PORTAL } from "../Routes";

const ViewEmployeeDetailButton: FC<CustomCellRendererProps> = ({ data }) => {
  const navigate = useNavigate();
  return (
    <Button
      onClick={() => {
        navigate(`${EMPLOYEE_PORTAL}/${data.id}`);
      }}
      variant="text"
      startIcon={<RemoveRedEyeIcon />}
    >
      View more...
    </Button>
  );
};

export default ViewEmployeeDetailButton;
